import React, { useEffect, forwardRef } from "react";
import "./input.css";

function Input({
  className,
  children,
  primary,
  secondary,
  placeholder,
  value,
  type,
  name,
  datalist,
  icon,
  iconHandler,
  autoComplete,
  onInput,
  onChange,
  onFocus,
  onClick,
  onInvalid,
  required
}, ref) {
  const inputClass = secondary ? "input-secondary" : "input-primary";
  const iconed = icon ? 'iconed' : '';
  const classes = [inputClass, className, iconed].join(" ");
  
  let iconElement = icon ? <div className="input-icon" onClick={iconHandler}></div> : null;
  
  useEffect(() => {
  }, []);

  const _onFocus = (e) => {
    e.target.parentNode.classList.toggle('focus');
  }

  const handleOnChange = (e) => {
    // if (_onChange) _onChange(e);
    if (onChange) onChange(e);
  }
  
  const handleOnFocus = (e) => {
    if (_onFocus) _onFocus(e);
    if (onFocus) onFocus(e);
  }

  const handleClickOnParent = () => {
    // console.log(e.nativeEvent)
  }

  if (datalist) {
    let dataListItems = datalist.map((item, idx) => <option value={item} key={idx}/>);
    datalist = (
      <datalist id="datalist">
        {dataListItems}
      </datalist>
    )    
  }

  return (
    <div className={classes} onClick={handleClickOnParent}>
      {iconElement}
      <input
      required={required}
        onInput={onInput}
        onChange={handleOnChange}
        onFocus={handleOnFocus}
        onBlur={handleOnFocus}
        onInvalid={onInvalid}
        onClick={onClick}
        value={value}
        type={type}
        ref={ref}
        placeholder={placeholder}
        autoComplete={autoComplete}
        list={datalist ? 'datalist' : undefined}
      >
        {children}
      </input>
      {datalist}
    </div>
  );
}

export default forwardRef(Input);
